import { eventBus } from "@/infrastructure/services";
import { handleAiGenerated } from "../handlers/aiGeneratedHandler";
import socketEvents from "../constants/socketEventsDictionary";

export function registerSocketEventHandlers() {
	eventBus.on(socketEvents.AI_GENERATED, handleAiGenerated);
}
